import {
  createHevitonApiAppLegacy,
  type HevitonApiAppLegacy,
} from '@heviton/heviton-api-app-legacy';
import { useAuthStore } from '@/entities/auth';
import { env } from '@/env';
import type { ApiCallbacks } from './api-callbacks';

/**
 * `HevitonApiAppLegacy` factory — composition root 가 호출하는 wrapper.
 *
 * refresh 오케스트레이션은 composition 의 공통 `refreshToken` 이 소유(주입)한다 — refresh HTTP·refresh
 * 토큰 bearer 헤더까지 composition 이 담당하므로, 본 wrapper 는 access 게터와 횡단 콜백만 배선한다.
 */
export function createApiAppLegacy(
  callbacks: ApiCallbacks,
  refreshToken: () => Promise<string | null>,
): HevitonApiAppLegacy {
  return createHevitonApiAppLegacy({
    baseURL: env.api.appLegacy.baseUrl,
    getAccessToken: () => useAuthStore.getState().accessToken,
    refreshToken,
    ...callbacks,
  });
}
